import stringFormatService from '../../services/stringFormatService';
import {config} from '../config';
import {TConfigGetterReturn} from './types';

const getBaseName = (): TConfigGetterReturn<number> => config.data.app.baseName;

const getIsQuickStartGuideBannerEnabledByType = (deviceType: string) => {
    const deviceTypeList = config.data.app.quickStartGuideBanner as any;

    return deviceTypeList?.some((item: string) => item === deviceType);
};

export default {
    getAppVersion: (): TConfigGetterReturn<string> => config.data.app.appVersion,
    getBackendType: (): TConfigGetterReturn<number> => config.data.app.backendType,
    getBaseNameFormatted: (): TConfigGetterReturn<string> =>
        stringFormatService.getLanguageFormattedString(getBaseName()),
    getDefaultVeevImage: (): TConfigGetterReturn<string> => config.data.app.defaultVeevImage,
    getDeviceListOrder: (): TConfigGetterReturn<string[]> => config.data.app.deviceListOrder,
    getEnv: (): TConfigGetterReturn<string> => config.data.app.env,
    getIsAccessProtected: (): TConfigGetterReturn<boolean> => config.data.app.isAccessProtected,
    getIsDeviceSettingAvailable: (): TConfigGetterReturn<boolean> => config.data.app.isDeviceSettingAvailable,
    getIsQualtricsTrackingEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isQualtricsTrackingEnabled,
    getIsReconnectDeviceGuideEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isReconnectDeviceGuideEnabled,
    getIsRememberMeEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isRememberMeEnabled,
    getIsTestLoginEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isTestLoginEnabled,
    getIsTipsAndTutorialsMenuItemEnabled: () => config.data.app.isTipsAndTutorialsMenuItemEnabled,
    getIsDataCollectionEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isDataCollectionEnabled,
    getYapMode: (): TConfigGetterReturn<number> => config.data.app.yapMode,
    getRtlLanguageCodes: (): TConfigGetterReturn<string[]> => config.data.app.rtlLanguageCodes,
    getIsBrowserCompatiblePageEnabled: (): TConfigGetterReturn<boolean> =>
        returnValueOrTrue(config.data.app.isBrowserCompatiblePageEnabled),
    getIsQuickStartGuidePageEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isQuickStartGuidePageEnabled,
    getIsQuickStartGuideBannerEnabled: (deviceType: string): TConfigGetterReturn<boolean> =>
        getIsQuickStartGuideBannerEnabledByType(deviceType),
    getToastNotificationDisplayTime: (): TConfigGetterReturn<number> => config.data.app.toastNotificationDisplayTime,
    getIsWarningIconEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isWarningIconEnabled,
    getIsDeviceBusyMessageEnabled: (): TConfigGetterReturn<boolean> => config.data.app.isDeviceBusyMessageEnabled,
    getIsPairingDelayOnWindowsEnabled: (): TConfigGetterReturn<boolean> =>
        config.data.app.isPairingDelayOnWindowsEnabled,
    getIsUnderlineAnimationDisabled: (): TConfigGetterReturn<boolean> => config.data.app.isUnderlineAnimationDisabled,
    getIsSuccessfullyUpdatedPageIconEnabled: (): TConfigGetterReturn<boolean> =>
        config.data.app.isSuccessfullyUpdatedPageIconEnabled,
    getHidePartOfCodentify: (): TConfigGetterReturn<{start: number; end: number} | undefined> =>
        config.data.app.hidePartOfCodentify,
};

const returnValueOrTrue = (value: boolean | undefined) => {
    if (value === undefined) {
        return true;
    } else {
        return value;
    }
};
